import { matchesMultiSelectExact } from './premiacaoMultiSelectFilters';

const normalizeText = (value) => String(value || '').trim().toLowerCase();

const matchesContains = (fieldValue, filterValue) => {
  const filter = normalizeText(filterValue);
  if (!filter) {
    return true;
  }
  return normalizeText(fieldValue).includes(filter);
};

const matchesVinculoStatus = (temVinculo, statusVinculo) => {
  const status = String(statusVinculo || 'todos').trim().toLowerCase();
  if (!status || status === 'todos') {
    return true;
  }
  if (status === 'com') {
    return temVinculo === true;
  }
  if (status === 'sem') {
    return temVinculo !== true;
  }
  return true;
};

export const filtrarVeiculosAssociacao = (lista, filtros) => {
  const filtrosAtivos = filtros || {};

  return lista.filter((item) => {
    if (!matchesContains(item.numeroFrota, filtrosAtivos.NumeroFrota)) {
      return false;
    }
    if (!matchesContains(item.placa, filtrosAtivos.Placa)) {
      return false;
    }
    if (!matchesMultiSelectExact(item.segmento, filtrosAtivos.Segmento)) {
      return false;
    }
    if (!matchesMultiSelectExact(item.modelo, filtrosAtivos.Modelo)) {
      return false;
    }
    if (!matchesVinculoStatus(item.temVinculo, filtrosAtivos.StatusVinculo)) {
      return false;
    }
    return true;
  });
};

export const filtrarTabelasAssociacao = (lista, filtros) => {
  const filtrosAtivos = filtros || {};

  return lista.filter((item) => {
    if (!matchesContains(item.id, filtrosAtivos.Id)) {
      return false;
    }
    if (!matchesContains(item.nome, filtrosAtivos.Nome)) {
      return false;
    }
    if (!matchesMultiSelectExact(item.segmento, filtrosAtivos.Segmento)) {
      return false;
    }
    if (!matchesVinculoStatus(item.temVinculo, filtrosAtivos.StatusVinculo)) {
      return false;
    }
    return true;
  });
};
